import { render, staticRenderFns } from "./TemplateStepTipoSolicitacao.vue?vue&type=template&id=110da6c2&scoped=true"
import script from "./TemplateStepTipoSolicitacao.vue?vue&type=script&lang=js"
export * from "./TemplateStepTipoSolicitacao.vue?vue&type=script&lang=js"
import style0 from "./TemplateStepTipoSolicitacao.vue?vue&type=style&index=0&id=110da6c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110da6c2",
  null
  
)

export default component.exports